import IdLessRestService from "./IdLessRestService";


export default class PasswordService extends IdLessRestService {
    constructor(parentService) {
        if (parentService) {
           super(`${parentService.baseUrl}/password`)
        }
        else
            throw new Error("Can be only nested service")
    }
}
